export default {
  form: {
    tax_id: {
      label: 'Número fiscal',
      placeholder: 'Ingresar número fiscal',
    },
    has_vat: {
      label: '¿Tu empresa está registrada en el IVA?',
    },
    vat_id: {
      label: 'IVA',
      placeholder: 'IVA',
      tooltip: 'El número de IVA es un identificador fiscal único de tu empresa',
    },
    tax_percentage: {
      label: 'Porcentaje de impuesto',
      placeholder: 'Porcentaje de impuesto',
    },
    has_dedicated_products_tax: {
      label: 'El % de impuesto varía según el producto',
    },
  },
  buttons: {
    next: 'Siguiente',
    back: 'Atrás',
    skip: 'Omitir',
  },
};
